import React from "react";
import { Breadcrumb } from "react-bootstrap";
import { Link, useMatches } from "react-router-dom";
// Corrected relative path for your flat structure
import { useCTISSchema } from "../../channels/ctis/pages/CTISSchemaProvider";

export default function Breadcrumbs() {
  const matches = useMatches();
  const schema = useCTISSchema(); 
  const activeTemplate = schema?.activeTemplate;

  // Filter and map routes that have a defined 'crumb'
  const dynamicCrumbs = matches
    .filter((match) => match.handle?.crumb)
    .map((match) => {
      let label = match.handle.crumb;

      // SIZZLE: Use the official EMA name if we are in the template renderer
      if (label === "Template View" && activeTemplate) {
        label = activeTemplate.template_metadata?.official_sheet_name || label;
      }

      return {
        label: label,
        to: match.pathname
      };
    });

  // Build final array starting with Home
  const crumbs = [
    { label: "Home", to: "/" },
    ...dynamicCrumbs.filter((crumb) => crumb.to !== "/")
  ];

  return (
    <nav aria-label="breadcrumb" className="mb-4">
      <Breadcrumb 
        className="ctis-breadcrumb" 
        style={{ 
          backgroundColor: 'transparent', 
          padding: 0 
        }}
      >
        {crumbs.map((crumb, index) => {
          const isLast = index === crumbs.length - 1;

          return (
            <Breadcrumb.Item
              key={`${crumb.to}-${index}`}
              linkAs={!isLast ? Link : "span"}
              linkProps={!isLast ? { to: crumb.to } : undefined}
              active={isLast}
              className="breadcrumb-item-custom"
            >
              <span style={{ 
                textDecoration: 'none', 
                color: isLast ? '#6c757d' : '#212529',
                fontWeight: isLast ? '600' : '400'
              }}>
                {crumb.label}
              </span>
            </Breadcrumb.Item>
          );
        })}
      </Breadcrumb>

      {/* Internal CSS to ensure links are undecorated */}
      <style>{`
        .ctis-breadcrumb a {
          text-decoration: none !important;
          color: #212529;
        }
        .ctis-breadcrumb a:hover {
          color: #0d6efd;
          text-decoration: none !important;
        }
        .breadcrumb-item + .breadcrumb-item::before {
          content: "›";
          font-weight: bold;
        }
      `}</style>
    </nav>
  );
}